import { ILocalization, parseDate } from 'bernie-l10n';

import { DateInput } from '__generated__/api';

export class DateUtils {
  private localization: ILocalization;

  constructor(l10n?: ILocalization) {
    this.localization = l10n;

    this.getISODayAfter = this.getISODayAfter.bind(this);
    this.getISODayBefore = this.getISODayBefore.bind(this);
    this.getNDaysFrom = this.getNDaysFrom.bind(this);
    this.getToday = this.getToday.bind(this);
    this.isSame = this.isSame.bind(this);
  }

  public getDaysBetween(startISODate, endISODate) {
    const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

    const endDateString = parseDate(endISODate).toString();
    const startDateString = parseDate(startISODate).toString();

    return Math.floor((Date.parse(endDateString) - Date.parse(startDateString)) / MILLISECONDS_PER_DAY);
  }

  public getISODayAfter(currentISODate) {
    return this.getNDaysFrom(currentISODate, 1);
  }

  public getISODayBefore(currentISODate) {
    return this.getNDaysFrom(currentISODate, -1);
  }

  public getNDaysFrom(currentISODate, n) {
    const currentDate = parseDate(currentISODate);
    const isoDayBefore = parseDate(currentISODate);
    isoDayBefore.setDate(currentDate.getDate() + n);

    return this.localization.formatDate(isoDayBefore, { raw: 'yyyy-MM-dd' });
  }

  public getToday() {
    const todayAsDate = new Date();
    const normalizedDate = new Date(todayAsDate.getFullYear(), todayAsDate.getMonth(), todayAsDate.getDate());

    return this.localization.formatDate(normalizedDate, { raw: 'yyyy-MM-dd' });
  }

  public static isBefore(firstISODate, secondISODate) {
    const firstDate = parseDate(firstISODate);
    const secondDate = parseDate(secondISODate);

    return firstDate < secondDate;
  }

  public isSame(firstISODate, secondISODate) {
    const firstDate = parseDate(firstISODate);
    const secondDate = parseDate(secondISODate);

    return firstDate.getTime() === secondDate.getTime();
  }

  public static parseDateString(dateString: string): DateInput | null {
    const dateParts = dateString.split('-');

    if (!dateParts || dateParts.length !== 3) {
      return null;
    }

    return {
      day: Number.parseInt(dateParts[2], 10),
      month: Number.parseInt(dateParts[1], 10),
      year: Number.parseInt(dateParts[0], 10)
    };
  }
}
